import { faCircleInfo } from '@fortawesome/pro-solid-svg-icons/faCircleInfo';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import { FunctionComponent } from 'react';
import styles from './NoneMembership.module.css';

export interface NoneMembershipProps {
    className?: string;
}

export const NoneMembership: FunctionComponent<NoneMembershipProps> = props => {
    return (
        <div className={clsx(styles.container, props.className)}>
            <div className={styles.left}>
                <FontAwesomeIcon
                    icon={faCircleInfo}
                    color="#BAA997"
                    className={styles.icon}
                />
                <span className={styles.text}>No available membership to redeem, usage limit reached</span>
            </div>
        </div>
    );
};

export default NoneMembership;
